var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailureCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 170,
    viewBox: "0 0 171 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -24.5,
    y: -25,
    width: 220,
    height: 220
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(20px)",
      clipPath: "url(#bgblur_0_5637_12689_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5637_12689)",
    "data-figma-bg-blur-radius": 40
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148 85C148 119.518 120.018 147.5 85.5 147.5C50.9822 147.5 23 119.518 23 85C23 50.4822 50.9822 22.5 85.5 22.5C120.018 22.5 148 50.4822 148 85Z",
    fill: "#E03616",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 85C148 119.518 120.018 147.5 85.5 147.5C50.9822 147.5 23 119.518 23 85C23 50.4822 50.9822 22.5 85.5 22.5C120.018 22.5 148 50.4822 148 85Z",
    stroke: "#E03616",
    strokeWidth: 15,
    strokeLinecap: "round",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5604 66.0604C68.391 64.2299 71.359 64.2299 73.1896 66.0604L85.5001 78.3709L97.8104 66.0606C99.641 64.23 102.609 64.23 104.44 66.0606C106.27 67.8911 106.27 70.8591 104.44 72.6897L92.1292 85.0001L104.439 97.3103C106.27 99.1409 106.27 102.109 104.439 103.939C102.609 105.77 99.6409 105.77 97.8103 103.939L85.5001 91.6292L73.1897 103.94C71.3591 105.77 68.3912 105.77 66.5606 103.94C64.73 102.109 64.73 99.141 66.5606 97.3104L78.8709 85.0001L66.5604 72.6896C64.7299 70.859 64.7299 67.891 66.5604 66.0604Z",
    fill: "#E03616"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5637_12689",
    x: -24.5,
    y: -25,
    width: 220,
    height: 220,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.211765 0 0 0 0 0.0862745 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5637_12689"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5637_12689",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5637_12689_clip_path",
    transform: "translate(24.5 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148 85C148 119.518 120.018 147.5 85.5 147.5C50.9822 147.5 23 119.518 23 85C23 50.4822 50.9822 22.5 85.5 22.5C120.018 22.5 148 50.4822 148 85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureCircle);
export default __webpack_public_path__ + "static/media/FailureCircle.ae70726b3704977a4c019dccb4720a47.svg";
export { ForwardRef as ReactComponent };